// extracted by mini-css-extract-plugin
export default {"root":"Payment_root__LUdhu","main":"Payment_main__ZevVT","heading":"Payment_heading__ymTxW","resumesContainer":"Payment_resumesContainer__UFERP","finished":"Payment_finished__60mzb"};